import {
  adjustmentSessionIdFormat,
  inboundShipmentIdFormat,
  locationIdFormat,
} from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

import { AdjustmentSessionKind } from "@redotech/redo-prisma-client/enums";
import { createEnum } from "@redotech/zod-util/zod-enum";

const AdjustmentSessionProductSchema_ = z.object({
  productId: productIdFormat.schema,
  quantity: z.number(),
});

export const AdjustmentSessionProductSchema: z.ZodType<AdjustmentSessionProductSchema> =
  AdjustmentSessionProductSchema_;
export interface AdjustmentSessionProductSchema extends z.infer<
  typeof AdjustmentSessionProductSchema_
> {}

const AdjustmentSessionSchema_ = z.object({
  id: adjustmentSessionIdFormat.schema,
  accountId: zExt.objectId(),
  locationId: locationIdFormat.schema,
  destinationLocationId: locationIdFormat.schema.nullable(),
  legacyUserId: z.string(),
  kind: createEnum(AdjustmentSessionKind),
  sourceId: z.string().nullable(),
  inboundShipmentId: inboundShipmentIdFormat.schema.nullable(),
  parentSessionId: adjustmentSessionIdFormat.schema.nullable(),
  notes: z.string().nullish(),
  status: createEnum([
    "in_progress",
    "submitted",
    "completed",
    "cancelled",
    "reversed",
  ]),
  createdAt: z.string(),
  updatedAt: z.string(),
  submittedAt: z.string().nullable(),
  completedAt: z.string().nullable(),
  deletedAt: z.string().nullable(),
});

export const AdjustmentSessionSchema: z.ZodType<AdjustmentSession> =
  AdjustmentSessionSchema_;
export interface AdjustmentSession extends z.infer<
  typeof AdjustmentSessionSchema_
> {}

export const createAdjustmentSession = {
  name: "createAdjustmentSession" as const,
  input: z.object({
    locationId: locationIdFormat.schema,
    destinationLocationId: locationIdFormat.schema.optional(),
    kind: createEnum(AdjustmentSessionKind),
    sourceId: z.string(),
    inboundShipmentId: inboundShipmentIdFormat.schema.optional(),
    notes: z.string().optional(),
  }),
  output: z.object({ session: AdjustmentSessionSchema }),
};
